import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { finalize } from 'rxjs';
import { environment } from '../../../environments/environment';
import { ParkingEditLocationProposalSaveData } from '../../_types/parking-edit-location-proposal.type';
import { GlobalLoaderService } from '../_core/global-loader.service';

@Injectable({
  providedIn: 'root',
})
export class ParkingEditLocationApiService {
  private _httpClient = inject(HttpClient);
  private _globalLoaderService = inject(GlobalLoaderService);

  addEditLocationProposal(id: number, body: ParkingEditLocationProposalSaveData) {
    this._globalLoaderService.show();
    return this._httpClient
      .post(`${environment.apiUrl}/parking-points/${id}/edit-location/`, body)
      .pipe(finalize(() => this._globalLoaderService.hide()));
  }
}
